import faces from "./fonts.module.css";
import variants from "./variants.json";

interface GoogleFontOptions {
  weight: string[] | "variable";
  subsets: string[];
  display: "swap";
  axes?: string[];
}

export interface SelfHostedFont {
  className: string;
  style: { fontFamily: string; fontWeight?: number; fontStyle?: string };
}

interface Variant {
  className: string;
  style: SelfHostedFont["style"];
}

// The same key as variantKey in scripts/fonts/self-host-google-fonts.mjs.
const variantKey = (font: string, options: GoogleFontOptions) =>
  `${font} ${JSON.stringify(options, Object.keys(options).sort())}`;

/**
 * Called like its next/font/google namesake, a family returns the class and font stack next/font/google returned for
 * the same options. Options the files were not downloaded for throw, so the build fails instead of a page synthesising
 * a weight Google would have served.
 */
function googleFont(font: string) {
  return (options: GoogleFontOptions): SelfHostedFont => {
    const variant = (variants as Record<string, Variant>)[
      variantKey(font, options)
    ];
    if (!variant)
      throw new Error(
        `${font}(${JSON.stringify(options)}) is not in src/fonts/google. Run node scripts/fonts/self-host-google-fonts.mjs.`,
      );
    return { className: faces[variant.className], style: variant.style };
  };
}

export const Arya = googleFont("Arya");
export const Bodoni_Moda = googleFont("Bodoni_Moda");
export const Cormorant_Garamond = googleFont("Cormorant_Garamond");
export const DM_Sans = googleFont("DM_Sans");
export const Fraunces = googleFont("Fraunces");
export const Inter = googleFont("Inter");
export const Jost = googleFont("Jost");
export const Lato = googleFont("Lato");
export const Merriweather = googleFont("Merriweather");
export const Montserrat = googleFont("Montserrat");
export const Playfair_Display = googleFont("Playfair_Display");
export const Plus_Jakarta_Sans = googleFont("Plus_Jakarta_Sans");
export const Prata = googleFont("Prata");
export const Quicksand = googleFont("Quicksand");
export const Roboto = googleFont("Roboto");
export const Roboto_Slab = googleFont("Roboto_Slab");
export const Titillium_Web = googleFont("Titillium_Web");
export const Work_Sans = googleFont("Work_Sans");
